import { customerBaseApi } from "@/react/services/api/api";
import { SMS_CAMPAIGNS } from "@/react/features/smp/licenses/constants";

const smsCampaignBaseUrl = "sms-campaigns";

export const smsCampaignApi = customerBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    retrieveCustomerCampaigns: builder.query({
      query: () => ({
        url: smsCampaignBaseUrl,
        method: "GET",
      }),
      providesTags: [SMS_CAMPAIGNS],
    }),
    replaceCustomerCampaign: builder.mutation({
      query: (campaignId) => ({
        url: `${smsCampaignBaseUrl}/${campaignId}`,
        method: "PUT",
      }),
      invalidatesTags: [SMS_CAMPAIGNS],
    }),
  }),
});

export const {
  useRetrieveCustomerCampaignsQuery,
  useReplaceCustomerCampaignMutation,
} = smsCampaignApi;
